export interface IStrongBoxFilter {
    id?: number,
    startDate?: Date,
    endDate?: Date,
    isCenter?: boolean
}

export interface IStrongBoxCenterFilter extends IStrongBoxFilter {
    centerId?: number,
}

export interface IStrongBoxOpoFilter extends IStrongBoxFilter {
    opoId?: number,
}